<template>
  <div class="animated fadeIn">
    <button
      type="button"
      class="btn btn-primary mr-2"
      title="Visualizar histórico do GAAU"
      @click="OpenModal"
    >
      <i class="fas fa-history"></i>
    </button>
    <b-modal
      v-model="modal"
      title="Histórico de Versões"
      class="modal-danger"
      size="lg"
      hide-footer
    >
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <b-table
        v-else
        :hover="true"
        responsive
        :items="itens"
        :fields="fields"
        striped
        :per-page="itemPerPage"
        show-empty
        empty-text="Nenhum histórico de gaau encontrado."
      >
        <template v-slot:empty="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(date)="data">
          <div class="center">
            <span>
              {{ FormatDate(data.item.date) }}
            </span>
          </div>
        </template>
        <template v-slot:cell(result)="data">
          <div class="center">
            <span>
              {{ ResultName(data.item.result) }}
            </span>
          </div>
        </template>
        <template v-slot:cell(acoes)="data">
          <div class="btn-group-sm">
            <b-button
              variant="warning"
              class="mr-2"
              title="Visualizar gaau"
              @click="ViewVersion(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="page"
        :total-rows="total"
        :per-page="itemPerPage"
        size="md"
        class="mt-2"
        align="right"
      ></b-pagination>
    </b-modal>
  </div>
</template>
  
  <script>
import RotateSquare from "../../components/RotateSquare";
import GaauService from "../../servico/GaauService";
import DateTime from "../../util/DateTime";

export default {
  name: "GaauHistory",
  components: {
    RotateSquare,
    GaauService
  },
  props: {
    gaauId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      modal: false,
      page: 1,
      itemPerPage: 20,
      total: 0,
      itens: [],
      fields: [
        { key: "version", label: "Versão", sortable: true },
        { key: "date", label: "Data", sortable: true },
        { key: "result", label: "GAAU", sortable: true },
        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },

  mounted() {
    this.modal = false;
  },
  methods: {
    ViewVersion(item) {
      let url = "/#/gaau/editar/" + this.gaauId + "/version/" + item.version;
      window.open(url, "_blank");
    },
    OpenModal() {
      this.modal = true;
      this.GetGrid(1);
    },
    GetGrid(pagina) {
      this.loading = true;

      GaauService.GetHistoryGrid(pagina, this.itemPerPage, this.gaauId)
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.page = response.data.pagina;
          this.itemPerPage = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    ResultName(result) {
      return GaauService.ResultName(result);
    },
    FormatDate(date) {
      return DateTime.FormatLocale(date);
    }
  }
};
</script>
  